function postMessage(frame, action, data, targetOrigin = '*') {
  const ob = {
    action,
    data
  };
  frame.contentWindow.postMessage(JSON.stringify(ob), targetOrigin);
}

export default postMessage;
